import React, { useState } from "react";
import { Box } from "@mui/system";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useEventsStore } from "../../stores/events.store";

export interface ActivitiesBarProps {}
const items = [
  { key: "activity", label: "Activité" },
  { key: "competition", label: "Compétition" },
  { key: "event", label: "Événement" },
  { key: "accomodation", label: "Hébergement" },
  { key: "restaurant", label: "Restaurant" },
];

export const ActivitiesBarComponent: React.FC<ActivitiesBarProps> = () => {
  const { event, setEvent } = useEventsStore();
  const [alignment, setAlignment] = useState(event);

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string
  ) => {
    setAlignment(newAlignment);
    setEvent(newAlignment);
  };

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#FFFDF7",
        borderRadius: "8px",
        display: "flex",
        justifyContent: "center",
        overflowX: "auto",
      }}
    >
      <ToggleButtonGroup
        value={alignment}
        exclusive
        onChange={handleChange}
        aria-label="categories"
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: { xs: "flex-start", sm: "space-around" },
        }}
      >
        {items.map((item) => (
          <ToggleButton
            key={item.key}
            value={item.key}
            sx={{
              textTransform: "none",
              fontSize: { xs: "12px", sm: "13px" },
              fontWeight: "600",
              width: { xs: "auto", sm: "100%" },
              whiteSpace: "nowrap",
              padding: { xs: "6px 10px", sm: "6px 16px" },
              border: "none",
              borderRadius: "8px !important",
              color: alignment === item.key ? "#fff" : "#555",
              background:
                alignment === item.key
                  ? "linear-gradient(90deg, #B4006E, #FF008D)"
                  : "transparent",
              transition: "0.25s ease",
              "&.Mui-selected": {
                color: "#fff",
                background: "linear-gradient(90deg, #B4006E, #FF008D)",
                "&:hover": {
                  background: "linear-gradient(90deg, #B4006E, #FF008D)",
                },
              },
              "&:hover": {
                background: alignment === item.key ? "" : "rgba(0,0,0,0.04)",
              },
            }}
          >
            {item.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};
